import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var container = /*#__PURE__*/css(".modal__inner{padding:10px;.modal__content{", media('<tablet'), "{@supports (-webkit-overflow-scrolling:touch){padding-bottom:65px;}}}}");